import type { CellContext } from '@tanstack/react-table';
import type { DataGridColumnDef, DataGridColumnTypeConfig, DataGridSimpleTypeColumnDef } from '../data-grid.type';

export function getColumnDefFormat<T>(col: DataGridColumnDef<T>) {
	if (!('format' in col) || !col.format) {
		throw new Error('Column must have a format function defined');
	}

	return function FormattedCell(context: CellContext<T, unknown>) {
		const value = context.getValue() as DataGridColumnTypeConfig[typeof col.type]['value'];

		return (col as DataGridSimpleTypeColumnDef<T, 'custom'>).format!(value);
	};
}
